import { Injectable } from '@angular/core';
import localforage from 'localforage';
import { Subject } from 'rxjs';
import { SALE_FORMAT_STEP } from 'src/app/pages/service/pages/account-page/enum/sale-format-step.enum';
import { ISaleFormatStep } from 'src/app/pages/service/pages/account-page/interface/sale-format-step.interface';
import { LOCAL_DATABASE } from '../../enums/storage/local-database.enum';

@Injectable({
  providedIn: 'root',
})
export class SaleFormatStepsService {
  MAX_STEPS = 5;

  onBack$: Subject<ISaleFormatStep> = new Subject<ISaleFormatStep>();
  onForward$: Subject<ISaleFormatStep> = new Subject<ISaleFormatStep>();
  reloadAction$ = new Subject<void>();

  private readonly _onStepChanged: Subject<void> = new Subject<void>();
  onStepChanged$ = this._onStepChanged.asObservable();

  private _steps: ISaleFormatStep[] = [];
  get steps(): ISaleFormatStep[] {
    return this._steps;
  }

  private _currentStep!: ISaleFormatStep;
  get currentStep(): ISaleFormatStep {
    return this._currentStep;
  }

  set currentStep(value: ISaleFormatStep) {
    this._currentStep = value;
    this._steps.push(value);
    this.limitStepsToMax();
    this.notifyStepChanged();
  }

  notifyStepChanged(): void {
    this._onStepChanged.next();
  }

  private limitStepsToMax(): void {
    if (this._steps.length > this.MAX_STEPS) {
      this._steps = this._steps.slice(-this.MAX_STEPS);
    }
  }

  forward(step: ISaleFormatStep): void {
    this._steps.push(step);
    this.limitStepsToMax();
    this._currentStep = step;
    this.onForward$.next(step);
  }

  back(): void {
    this._steps.pop();
    let step = this._steps[this._steps?.length - 1];

    if (!this._steps || this._steps?.length === 0) {
      this._steps = [];
      step = { step: SALE_FORMAT_STEP.initial };
    }

    this._currentStep = step as ISaleFormatStep;
    this.onBack$.next(step as ISaleFormatStep);
  }

  clearData(): void {
    this.currentStep = { step: SALE_FORMAT_STEP.initial };
    this._steps = [];
  }

  deleteStepsFromDB(): void {
    localforage.removeItem(LOCAL_DATABASE.saleFormatsSteps);
  }

}
